import React, { useEffect} from 'react'
import { useNavigate, useParams } from 'react-router-dom';

const ProjectVideos = ({projectsVideos}) => {

    const { id } = useParams();
  

    useEffect(()=>{
        window.scrollTo(0, 0);
      },[])
    
      const navigate = useNavigate();
  
    // const youtubeLinks = [
    //         "https://www.youtube.com/embed/KGe1RgrisgQ?si=4fPgTAGsyQYC_WD0",
    //         "https://www.youtube.com/embed/YxxIqzOE-gA?si=SQn2rUzs8XAbZFGs",
    //         "https://www.youtube.com/embed/BLeyyRQ7P_s?si=irwVZEsczlQF2_jj",
    //         "https://www.youtube.com/embed/C5VUEpk50bU?si=IFax9KBALQZd9l-I",
    //         "https://www.youtube.com/embed/i6qco3CxUC4?si=qJC316ugFOUm2xb5",
    //         "https://www.youtube.com/embed/77kHri7gtQc?si=gA7tzYw9zicXaTd3",
    //         "https://www.youtube.com/embed/5L1d5o3R6iQ?si=_U8DpIqlTvzdyf7I",
    //         "https://www.youtube.com/embed/GG6N7nOJNrU?si=KnWyS7t-bUNj447p",
    //         "https://www.youtube.com/embed/g9C0CYOM3TY?si=EKYuk58ojngeMOkB",
    //         "https://www.youtube.com/embed/8S6A5QPt608?si=NSitkCmwMzeGP8oG",
    //         "https://www.youtube.com/embed/J6CTyF2E6Dc?si=I312WTBxT5bNFCOj",
    //         "https://www.youtube.com/embed/Wkc_Mu8uQhY?si=qLNcpd9nks7DY7Fn",
    //         "https://www.youtube.com/embed/Cjf7kM2nbkA?si=0Y1gTrPIcrG1t_Ug",
    //         "https://www.youtube.com/embed/mJHS95TPlFw?si=a06cnEunezRoA9VS",
    //         "https://www.youtube.com/embed/8jgm_8UtO18?si=IAMKwihWVnsJqgJ3",
    //         "https://www.youtube.com/embed/Gsvue2k9bnA?si=GV2erFVH-bKQpQ99",
    //         "https://www.youtube.com/embed/3QD8QzuN2wQ?si=9jQzKcfVU_PhBL9R",
    //         "https://www.youtube.com/embed/piYw1lnGjv0?si=EPY-01sAvd9Urf_w",
    //         "https://www.youtube.com/embed/rO3Fm3Bd3xU?si=2q04BPHaCq5hBaTt",
    //         "https://www.youtube.com/embed/eChibkbdK64?si=ZpLRSApC75Hs5Y-i",
    //         "https://www.youtube.com/embed/GSD-NQ4O3c8?si=bd32DaL6hxA7g4tl",
    //         "https://www.youtube.com/embed/5KyTuflJBkg?si=Cic9rpFwL2EjUPsu",
    //         "https://www.youtube.com/embed/aZW-6HgkhI0?si=wNxODFhLTSK-2Uhn",
    //         "https://www.youtube.com/embed/_NJRe1XJnWk?si=OEz5GO_x9yXt8THD",
    //         "https://www.youtube.com/embed/evkLJ2ms_xE?si=-UPZ5gE49HBif7Rj",
    //         "https://www.youtube.com/embed/-PShexmRZmQ?si=lcNrluF2k0KQXx-Y",
    //         "https://www.youtube.com/embed/ybB0DeQpwnE?si=RGOoHw8JIK2RVJbq",
    //         "https://www.youtube.com/embed/kS-SW7Gd8L4?si=FP_ioEKkqA7ByO-9"
    // ] 

    const projectVideo = projectsVideos[id]
    const youtubeLinks = projectVideo?.videos

  return (
    <div>
            <div className='min-h-[100vh] w-full px-6 md:px-12 lg:px-32 pt-[18vh] md:pt-[20vh] flex flex-col gap-4 items-center lg:pt-28 pb-12'>

                    <div className='w-[80%]'>
                    <h1 className='w-full text-center text-2xl md:text-4xl font-mosk300 flex flex-col md:flex-row md:gap-1 justify-center' ><span className='text-4xl font-mosk600' > {projectVideo.title} Videos</span></h1>
                    </div>

                    <div className='w-full flex justify-between items-start py-4 md:py-0' >
                        <div className='flex gap-1 font-mosk600 pb-0'>
                        <p className='cursor-pointer hidden md:block' onClick={()=> navigate('/projects')}>Projects</p>
                        <p className='hidden md:block'>/</p>
                        <p className='cursor-pointer' onClick={()=> navigate('/project-video-cards')}>project videos</p>
                        <p>/</p>
                        <p>{projectVideo.title}</p>
                        </div>
                    </div>

                    <div className='grid grid-cols-1 md:grid-cols-2 gap-8 py-8' >
                    {
                        youtubeLinks.map((link, index)=>{
                        return(
                            <iframe key={index} className='h-[30vh] md:h-[20vh] hover:drop-shadow-lg  lg:h-[50vh] w-[90vw] md:w-[40vw] lg:w-[35vw] rounded-lg' src={`https://www.youtube.com/embed/${link}`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                        )
                        })
                    }
                    </div>
                    </div>
    </div>
  )
}

export default ProjectVideos
